import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'src'
import { invalidateVesselCertificateQueries } from '~hooks/queries/vessels/invalidate-vessel-certificate-queries'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export function usePostDocuments({
  vesselId,
  refetch,
}: {
  vesselId: string
  refetch?: () => void
}) {
  const fetchRequest = useFetch()
  return useMutation({
    mutationFn: (formData: FormData) =>
      fetchRequest(
        `${apiBase()}/vessels/${vesselId}/documents`,
        undefined,
        undefined,
        'POST',
        formData,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [`/vessels/${vesselId}/documents`],
      })
      invalidateVesselCertificateQueries(vesselId)
      refetch?.()
    },
  })
}
